function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_950_2218)",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.731 9.347h-3.75v-3.75",
  strokeWidth: "1.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.303 18.111a8.485 8.485 0 004.401 2.465 8.24 8.24 0 004.968-.51 8.695 8.695 0 003.86-3.315 9.303 9.303 0 001.45-5.001c0-1.78-.505-3.52-1.45-5a8.695 8.695 0 00-3.86-3.316 8.24 8.24 0 00-4.968-.51 8.485 8.485 0 00-4.401 2.465L2.98 8.856",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.714 10.5l1.5-.75v4.5M15 9.75c-1.16 0-1.286 1.5-1.286 2.357 0 .847.19 2.143 1.286 2.143s1.286-1.357 1.286-2.143c0-.786-.125-2.357-1.286-2.357z",
  strokeWidth: "1.5"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_950_2218"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));